import moment from "moment";
export default {
  data() {
    return {
      dataUrl:
        "data:image/png;base64,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",
      numberRule: [(v) => v > 0 || "Number required"],
      textRules: [(v) => !!v || "Required"],
      textLengthRules: [
        (v) => !!v || "Required",
        (v) => v.length > 2 || "Text should be more than 2",
      ],
    };
  },
  methods: {
    shortToBoolean(str) {
      if (str === 1) {
        return true;
      } else {
        return false;
      }
    },
    truncateString(str, num) {
      console.log(str + " == " + num);
      try {
        if (str === null) {
          return "...";
        } else {
          if (str.length <= num) {
            return str;
          } else {
            return str.slice(0, num) + "...";
          }
        }
      } catch (error) {
        return "...";
      }
    },
    getPix(event) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.onloadend = (ev) => {
          resolve(ev.target.result);
        };
        reader.onerror = (ev) => {
          reject(ev);
        };
        reader.readAsDataURL(event);
      });
    },
    checkDate(date) {
      console.log(date);
      if (date === 0 || date === undefined || date === null) {
        return "";
      } else {
        return moment(date).format("YYYY-MM-YY");
      }
    },
    booleanToShort(bool) {
      let result = bool ? 1 : 0;
      return result;
    },
    myTiming(value) {
      if (value) {
        let con = Date.parse(value);
        // console.log(con);
        let formatted = moment(con).format("hh:mm A");
        return formatted;
      }
    },
    replaceWith_(value) {
      if (value) {
        let text = value.replace(/\s+/g, "_");
        return text;
      }
    },
    remove_(value) {
      if (value) {
        let text = value.replace("_", " ");
        return text;
      }
    },
    _encode(data) {
      return btoa(data);
    },
    _decode(data) {
      return atob(data);
    },
  },
};
